// pages/FormViewerPage/services/formViewerService/embedThanksAlign.ts
// Penyelarasan embed setelah order sukses: cegah kesan "blank page".
// Akar masalah: setelah submit, iframe ganti ke thanks (pendek) tapi scroll
// parent TETAP di bawah → viewport menampilkan area kosong di bawah iframe.
// Perbaikan sisi repo (tanpa perlu ubah builder):
//  1. scroll internal iframe ke atas,
//  2. kirim ulang form-resize (thanks lebih pendek dari form),
//  3. kirim cuanmax:scroll-to-form (didengar snippet builder BARU; snippet
//     lama mengabaikan tipe tak dikenal — aman backward compatible).

export function alignEmbedThanks(identifier?: string): void {
    try {
        window.scrollTo(0, 0);
    } catch { /* abaikan */ }
    const post = () => {
        try {
            window.parent?.postMessage({ type: 'cuanmax:scroll-to-form', identifier }, '*');
        } catch { /* abaikan */ }
        try {
            const el = document.querySelector('form') || document.getElementById('root');
            const h = Math.ceil(el?.getBoundingClientRect().height || 0);
            if (h > 50) {
                window.parent?.postMessage(
                    { type: 'cuanmax:form-resize', height: Math.max(160, h + 12), identifier }, '*'
                );
            }
        } catch { /* abaikan */ }
    };
    // Thanks render bertahap (skeleton → konten → gambar) — kirim 3x.
    setTimeout(post, 100);
    setTimeout(post, 600);
    setTimeout(post, 1500);
}

// Deteksi embed dari URL (sama dgn logika index.tsx) — utk pemakaian non-hook.
export function isEmbedUrl(search: string): boolean {
    try {
        const q = new URLSearchParams(search || '');
        const e = q.get('embed');
        return e === '1' || e === 'true' || e === 'simple' || e === 'full' || e === 'seamless';
    } catch {
        return false;
    }
}
